<div class="about_us_page header_top mb-5">
  <section class="abt_banner">
    <div class="container">
      <h5>About Us</h5>
    </div>
  </section>

  <section class="abt_sec mt-5">
    <div class="container">
      <div class="row aic">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <h6>A Beacon of Hope in Malabar & beyond</h6>
          <p>NCARE’s story began in 2010 at Nahas Hospital, ignited by the visionary Dr. Rajina E. P. That
            September, the center launched its first IVF batch, planting the seeds of a revolution in reproductive
            medicine. Two months later, Dr. Baiju Ahammed Kutty joined the crusade, fortifying NCARE’s expertise.
            A second center rose in Kannur in 2014 under Dr. Baiju’s leadership, followed by a facility in Calicut
            in 2018, where Dr. Sandhya Krishnan now works her magic.</p>
          <p>Today, NCARE is a powerhouse, performing over 2,500 IVF cycles annually—one of India’s and Kerala’s
            highest at an affordable cost. From oocyte freezing to advanced genetic screening, NCARE blends
            science and compassion with a success rate exceeding 50%.</p>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <img loading="lazy" fetchpriority="low" src="../../../assets/images/aboutus/abt_sec_1.webp" alt="About NCARE Image 1" width="100%" height="auto" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <img loading="lazy" fetchpriority="low" src="../../../assets/images/aboutus/abt_sec_2.webp" alt="About NCARE Image 2" width="100%" height="auto" />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <h6>Beyond the Lab: Healing Hearts and Holding Hands</h6>
          <p>Infertility isn’t just a medical puzzle; it’s an emotional odyssey. At NCARE, our counselors offer a
            safe haven for fears and dreams. It’s about resilience, hope, and human connection. Our nursing and
            support staff embody this with tender care and intuition.</p>
          <p>Dr. Rajina E. P., Dr. Baiju Ahammed Kutty, and Dr. Sandhya Krishnan tailor every treatment with
            compassion. Backed by expert embryologists using cryopreservation and embryo culture, they turn
            possibility into pregnancy.</p>
        </div>
      </div>
    </div>
  </section>

  <section class="state_act_art_lab">
    <div class="container">
      <h6>State of the Art Lab</h6>
      <p>Our facilities feature Bioclad walls, vinyl flooring, positive pressure ventilation, and advanced
        equipment like 15+ G210 triple gas incubators from CooperSurgical, a leader in reproductive technology.</p>
    </div>
  </section>

  <section class="video my-5">
    <div class="container">
      <div class="responsive-video">
        <iframe
          loading="lazy"
          width="100%"
          height="315"
          srcdoc='<style>
              *{padding:0;margin:0;overflow:hidden}
              html,body{height:100%}
              img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto;height:100%;object-fit:cover}
              span{display:flex;align-items:center;justify-content:center;color:white;font-size:30px;background:black;opacity:0.8}
            </style>
            <a href="https://www.youtube.com/embed/_QWcyKKrii4?autoplay=1">
              <img src="https://img.youtube.com/vi/_QWcyKKrii4/hqdefault.jpg" alt="YouTube Video">
              <span>▶</span>
            </a>'
          title="YouTube video player"
          frameborder="0"
          allowfullscreen>
        </iframe>
      </div>
    </div>
  </section>

  <section class="emergency_bg">
    <div class="container">
      <img loading="lazy" fetchpriority="low" src="../../../assets/images/aboutus/fwf.webp" alt="Emergency Support" width="100%" height="auto" />
    </div>
  </section>

  <section class="future_worth_fighting">
    <div class="container">
      <div class="fwf">
        <h6>A Future Worth Fighting For</h6>
        <p>For Indian women, proactive steps like egg freezing are vital. Since 2010, NCARE has been a promise of
          ethical care, innovation, and a fierce commitment to family building—one heartbeat at a time.</p>
        <p>To those standing at the crossroads of doubt and desire: you’re not alone. At NCARE, hope isn’t just a
          word—it’s a mission. Let’s write your next chapter together.</p>
      </div>
    </div>
  </section>
</div>
